import React, { Component, useState } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import $ from 'jquery'
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import duallistboxConfig from '../../commons/duallistbox/DuallistboxConfig.js'
import Loading from '../ui/Loading.js'
import Select from 'react-select'
import { ITEM_TIPO_PRODUCTO, ITEM_TIPO_MANO_DE_OBRA, esManoDeObra } from '../../commons/constants/itemsTipos';
import GridPagination from '../../commons/grid/GridPagination.jsx';
import 'react-select/dist/react-select.css'
// import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'moment/min/locales'
import 'react-datepicker/dist/react-datepicker.css'
import Switch from "react-switch"
import Security from '../../commons/security/Security.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import DireccionAutocompletar from '../direccionAutocompletar/DireccionAutocompletar'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import { Table, TableContainer, TableHead, TableRow, TableBody } from '@material-ui/core';
import { StyledTableCell } from '../../commons/utils/TableStyles';
import ModalDatosComerciales from './ModalDatosComerciales';
import GerenciadorPlanillaImportModal from './GerenciadorPlanillaImportModal';
import { GridToolbar, GridToolbarButton } from '../../commons/grid/GridToolbar.jsx';
import * as Utils from '../../commons/utils/Utils';
import swal from 'sweetalert'
import Swal from 'sweetalert2'

const TIPO_GESTOR_ID = 2

const ERROR_RAZON_SOCIAL_DUPLICADA = 'gerenciadoresRepository.errors.existe_un_gerenciador_con_ese_nombre_debe_ser_unico'

// Número de registro (opcional): vacío, solo espacios, null o undefined se envían como null;
// cualquier otro valor se envía tal cual (sin quitar guiones ni espacios).
export const normalizarCuit = (valor) => {
  if (valor === null || valor === undefined) return null;
  if (String(valor).trim() === '') return null;
  return valor;
}

// Decide cómo se presenta un error de guardado (POST/PUT) que llega rechazado por status HTTP.
// El 409 es la razón social duplicada (antes era 400) y se muestra inline, en la misma caja que el 400.
// El 400 no pasa por acá: AjaxHandler lo resuelve y lo maneja el .then. Cualquier otro status se
// delega al manejo genérico de AjaxHandler.
export const resolverErrorGuardado = (status) => {
  if (status === 409) return { inline: true, errors: [ERROR_RAZON_SOCIAL_DUPLICADA] };
  return { inline: false, errors: [] };
}

// VEC-3947: resultados por búsqueda en el combo de ítems de cada servicio (para ver más, se tipea).
const LIMITE_BUSQUEDA_ITEMS = 50;

class GerenciadoresAbm extends Component {
	constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();

    moment.locale('es');

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
        id: 0,
        razon_social: '',
        cuit: '',
        tipo: null,
        activo: true,
        telefono: '',
        observaciones: '',
        direccion: '',
        numero: '',
				subregiones: [],
				poderes: [],
				titulares: [],
				servicios: [],
				serviciosItems: {},
        localidad: null,
        envia_alerta: false,
        // VEC-3499 Sc. 04: null = sin tarifario (usa el Catálogo de Ítems).
        tarifarioId: null,

      },
      cecos:[{ id: 0, nombre: '124567'},{ id: 1, nombre: '9863456'}], // CAMBIAR POR WS
      regiones:[],
      jefes:[],
      personasCombo:[],
      responsables:[],
      subregiones:[],
      paises: [],
      provincias: [],
      localidades: [],
			poderesDisponibles: [],
			titularesDisponibles: [],
      subRegionesDisponibles: [],
      serviciosDisponibles: [],
      // VEC-3947: nombre de cada ítem visto ({itemId: label}), para mostrar los elegidos aunque no estén
      // entre los resultados de la búsqueda actual.
      nombresDeItems: {},
      // Tipo de cada ítem visto ({itemId: tipo}): reparte los elegidos entre las columnas Repuestos y Mano de Obra.
      tiposDeItems: {},
      itemsPorServicioFiltro: [],
      // VEC-4382: qué importación por planilla está abierta ('servicios' | 'items'), o null.
      planillaModal: null,
      // VEC-4382: la última recarga después de importar falló; el formulario puede tener servicios / ítems viejos.
      serviciosDesactualizados: false,
      itemsPorServicioPagina: 0,
      itemsPorServicioPorPagina: 5,
      estados: [{ id: 1, nombre: this.props.intl.formatMessage({ id: 'gerenciadoresAbm.state_name_activo', defaultMessage: 'Activo' })},{ id: 0, nombre: this.props.intl.formatMessage({ id: 'gerenciadoresAbm.state_name_inactivo', defaultMessage: 'Inactivo' })}],
      tipos: [],

      categorias: [],
      gerenciadores: [],
      errors: [],
			direccionForm: null,
			loading: false,
      showModalDatosComerciales: false,
      modalDatosComercialesKey: 0,
      editDatosComerciales: null,
      datosComerciales: [],
      // VEC-3499 Sc. 04: opciones del selector y el tarifario con el que se abrió la ficha (para
      // pedir confirmación si se lo cambia por otro).
      tarifarios: [],
      tarifarioOriginal: null,
    };

    this.handleEstadoChange = this.handleEstadoChange.bind(this);
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.handleProvinciaChange = this.handleProvinciaChange.bind(this);

    this.handleNotificacionesActivasChange = this.handleNotificacionesActivasChange.bind(this);
    this.handleInputFormChange = this.handleInputFormChange.bind(this);
    this.handleSelectFormChange = this.handleSelectFormChange.bind(this);
    this.handleDatePickerFormChange = this.handleDatePickerFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // VEC-3947: contenedores de los multiselect de "Ítems por servicio", para llevar su scroll al último chip.
    this.contenedoresMultiselect = {};
    // VEC-3947: caché de búsquedas por combo ({'servicioId|tipo': {texto: opciones}}). Vive en la instancia y no en
    // el combo, así sobrevive a cambiar de página (el combo se desmonta).
    this.cacheBusquedaItems = {};
    // Pedidos en curso por combo y texto: el combo no los deduplica (p. ej. el reintento al perder el foco).
    this.busquedasEnCurso = {};
    // `value` de cada combo memorizado: react-select v1 toma un array nuevo como una selección y
    // borra el texto que se está tipeando (onSelectResetsInput), así que no puede cambiar en cada render.
    this.valoresDeCombos = {};
    this.handleUsuarioFormChange = this.handleUsuarioFormChange.bind(this);
    this.handlePerfilChange = this.handlePerfilChange.bind(this);
    this.handleMovilChange = this.handleMovilChange.bind(this);
    this.handleGerenciadorChange = this.handleGerenciadorChange.bind(this);
    this.handleBasesChange = this.handleBasesChange.bind(this);
    this.handleLocalidadChange = this.handleLocalidadChange.bind(this);
		this.handleChangeDireccion = this.handleChangeDireccion.bind(this);
    this.handleEnviaAlertaChange = this.handleEnviaAlertaChange.bind(this);


    this.formValidation = new FormValidation({
			component: this,
			validators: {
        'formData.razon_social': (value) => Validator.notEmpty(value),
        'formData.contacto': (value) => Validator.notEmpty(value),
        'formData.direccionValid': (value) => Validator.notEmpty(value),
        'formData.tipo': (value) => Validator.notEmpty(value),
			}
    });

  }
  initForm() {
		this.setState({ loading: true });
    let component = this;


		Promise.all([
      this.ajaxHandler.getJson('/regiones', null),
      this.ajaxHandler.getJson('/gerenciadores/tipo/1/select',null),
      this.ajaxHandler.getJson('/paises/select',null),
      this.ajaxHandler.getJson('/subregiones',null),
      this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/gerenciadores/' + this.state.props.match.params.id) : null,
      this.ajaxHandler.getJson('/tipos-gerenciadores'),
			this.ajaxHandler.getJson('/movil-titulares'),
			this.ajaxHandler.getJson('/ordenestrabajo/estados'),
			ConfigBusiness.get('servicios.proveedores.habilitado') === 'true' ? this.ajaxHandler.getJson('/servicios/select', null) : null,
			this.puedeCambiarTarifario() ? this.ajaxHandler.getJson('/inventario/tarifarios/select', null) : null,
		]).then((data) => {
      let regiones = data[0];
      let gerenciadores = data[1];
      let paises = data[2];
      let subRegionesDisponibles = data[3];
      let formData = data[4];
			let tiposGerenciador = data[5];
			let titularesDisponibles = data[6];
      let poderesDisponibles = data[7];
			let serviciosDisponibles = data[8];
			let tarifarios = data[9];
			let direccionParams = {}

      if(formData){
        formData.tipo = formData.tipo ? formData.tipo.id : null;
				direccionParams = {
					calle: formData.direccion,
					numero: formData.numero,
					localidad: formData.localidad,
					provincia: formData.provincia,
					pais: formData.pais,
					latitud: formData.latitud,
					longitud: formData.longitud
				};

      }
        
      component.setState({
        regiones: regiones,
        gerenciadores: gerenciadores,
        subRegionesDisponibles: subRegionesDisponibles,
        paises: paises,
        tipos: tiposGerenciador,
				titularesDisponibles: titularesDisponibles,
				poderesDisponibles: poderesDisponibles,
				serviciosDisponibles: serviciosDisponibles ? serviciosDisponibles : [],
				tarifarios: tarifarios ? tarifarios : [],
				tarifarioOriginal: formData && formData.tarifarioId ? { id: formData.tarifarioId, nombre: formData.tarifarioNombre } : null,
				direccionForm: direccionParams
			});
			if(formData) component.setState({
				formData: formData
      });
			// VEC-3947: el nombre de los ítems ya elegidos (pueden no estar entre los primeros resultados del combo).
			if (formData && formData.serviciosItems && this.itemsPorServicioHabilitado()) {
				this.cargarNombresDeItems(formData.serviciosItems).catch(() => {}); // AjaxHandler ya mostró el error.
			}


      $(this.refs.duallistbox).bootstrapDualListbox({
        moveOnSelect: false,
        moveAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.options_label_mover_todos', defaultMessage: 'Mover todos' }),
        removeAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.options_label_remover_todos', defaultMessage: 'Remover todos' }),
        moveSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.options_label_mover_seleccionados', defaultMessage: 'Mover seleccionados' }),
        removeSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.options_label_remover_seleccionados', defaultMessage: 'remover_seleccionados' }),
        infoText: false,
        filterPlaceHolder: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.filter_placeholder', defaultMessage: 'Filtro' }),
        nonSelectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.label_sub_regiones_disponibles', defaultMessage: 'Sub Regiones Disponibles:' }),
        selectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_regions.label_sub_regiones_asignadas', defaultMessage: 'Sub Regiones Asignadas:' })
      });

      $(this.refs.duallistbox).bootstrapDualListbox(duallistboxConfig(this.props.intl));

			$(this.refs.duallistbox).change((e) => {

				let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
				formDataCopy.subregiones = $(this.refs.duallistbox).val();
				this.setState({
					formData: formDataCopy
				}, ()=>{ $(this.refs.duallistbox).bootstrapDualListbox('refresh', true);});
			});


			$(this.refs.duallistboxtitulares).bootstrapDualListbox({
        moveOnSelect: false,
        moveAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.options_label_mover_todos', defaultMessage: 'Mover todos' }),
        removeAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.options_label_remover_todos', defaultMessage: 'Remover todos' }),
        moveSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.options_label_mover_seleccionados', defaultMessage: 'Mover seleccionados' }),
        removeSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.options_label_remover_seleccionados', defaultMessage: 'Remover seleccionados' }),
        infoText: false,
        filterPlaceHolder: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.filter_placeholder', defaultMessage: 'Filtro' }),
        nonSelectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.label_titulares_disponibles', defaultMessage: 'Sub Regiones Disponibles:' }),
        selectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_holder.label_titulares_asignados', defaultMessage: 'Titulares Asignados:' })
      });

    $(this.refs.duallistboxtitulares).bootstrapDualListbox(duallistboxConfig(this.props.intl));

    $(this.refs.duallistboxtitulares).change((e) => {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.titulares = $(this.refs.duallistboxtitulares).val();
        this.setState({
            formData: formDataCopy
        }, ()=>{ $(this.refs.duallistboxtitulares).bootstrapDualListbox('refresh', true);});
    });


			$(this.refs.duallistboxpoderes).bootstrapDualListbox({
        moveOnSelect: false,
        moveAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.options_label_mover_todos', defaultMessage: 'Mover todos' }),
        removeAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.options_label_remover_todos', defaultMessage: 'Remover todos' }),
        moveSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.options_label_mover_seleccionados', defaultMessage: 'Mover seleccionados' }),
        removeSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.options_label_remover_seleccionados', defaultMessage: 'Remover seleccionados' }),
        infoText: false,
        filterPlaceHolder: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.filter_placeholder', defaultMessage: 'Filtro' }),
        nonSelectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.label_poderes_disponibles', defaultMessage: 'Mover todos' }),
        selectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_powers.label_poderes_asignados', defaultMessage: 'Mover todos' })
      });

      $(this.refs.duallistboxpoderes).bootstrapDualListbox(duallistboxConfig(this.props.intl));

        $(this.refs.duallistboxpoderes).change((e) => {

            let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
            formDataCopy.poderes = $(this.refs.duallistboxpoderes).val();
            this.setState({
                formData: formDataCopy
            }, ()=>{ $(this.refs.duallistboxpoderes).bootstrapDualListbox('refresh', true);});
        });

			if (ConfigBusiness.get('servicios.proveedores.habilitado') === 'true') {
				$(this.refs.duallistboxservicios).bootstrapDualListbox({
					moveOnSelect: false,
					moveAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.options_label_mover_todos', defaultMessage: 'Mover todos' }),
					removeAllLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.options_label_remover_todos', defaultMessage: 'Remover todos' }),
					moveSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.options_label_mover_seleccionados', defaultMessage: 'Mover seleccionados' }),
					removeSelectedLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.options_label_remover_seleccionados', defaultMessage: 'Remover seleccionados' }),
					infoText: false,
					filterPlaceHolder: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.filter_placeholder', defaultMessage: 'Filtro' }),
					nonSelectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.label_servicios_disponibles', defaultMessage: 'Servicios Disponibles:' }),
					selectedListLabel: component.props.intl.formatMessage({ id: 'gerenciadoresAbm.add_services.label_servicios_asignados', defaultMessage: 'Servicios Asignados:' })
				});

				$(this.refs.duallistboxservicios).bootstrapDualListbox(duallistboxConfig(this.props.intl));

				$(this.refs.duallistboxservicios).change((e) => {
					let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
					formDataCopy.servicios = $(this.refs.duallistboxservicios).val();
					// VEC-3947: un servicio que se quita se lleva su subconjunto de ítems.
					let serviciosItems = {};
					Object.keys(formDataCopy.serviciosItems || {}).forEach((servicioId) => {
						if (formDataCopy.servicios.indexOf(servicioId) !== -1) serviciosItems[servicioId] = formDataCopy.serviciosItems[servicioId];
					});
					formDataCopy.serviciosItems = serviciosItems;
					this.setState({
						formData: formDataCopy
					}, ()=>{ $(this.refs.duallistboxservicios).bootstrapDualListbox('refresh', true);});
				});
			}

      if (formData && formData.id) {
        this.fetchDatosComerciales(formData.id);
      }
    }).catch(function(error) {
			console.log(error);
			component.exit();
		}).finally(() => {
			this.setState({ loading: false });
    });

  }
  componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}
	componentWillMount() {
    if ((Security.hasPermission('GERENCIADORES_CREAR') && this.state.props.action === 'ADD') ||
			(Security.hasPermission('GERENCIADORES_MODIFICAR') && this.state.props.action === 'EDIT') ||
			(Security.hasPermission('GERENCIADORES_VISUALIZAR') && this.state.props.action === 'VIEW')) {
			this.ajaxHandler.subscribe(this);
			this.initForm();
		} else {
			this.setState({
				redirectTo: '/error'
			});
    }
	}

  getData(service, param) {
    let serviceURL ="";

    if ( service === "provincias" || service === "localidades"  ) {
      serviceURL = param ? (Config.get('apiUrlBase') + '/' + service + '/' + param+ '/select') : (Config.get('apiUrlBase') + '/' + service);
    } else {
      serviceURL = param ? (Config.get('apiUrlBase') + '/' + service + '/' + param) : (Config.get('apiUrlBase') + '/' + service);
    }
    return fetch(serviceURL, {
      method: 'GET',
			headers: {
				'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization-Token': localStorage.getItem("token")
			}
		})
		.then(response => {
      return AjaxHandler.handleResponseErrorsIsValid(response) ? response.json() : null;
    });
  }

  getSubRegiones() {
		return fetch(Config.get('apiUrlBase') + '/subregiones', {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization-Token': localStorage.getItem("token")
			}
		})
		.then(response => {
			return AjaxHandler.handleResponseErrorsIsValid(response) ? response.json() : null;
		});
  }
  handlePaisChange(object) {

    return new Promise((resolve, reject) => {
      if(object) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));

        // formDataCopy.pais = { id: object.value, label: object.label };
        formDataCopy.pais = { id: object.value, label: object.label };
        formDataCopy.provincia = null;
        formDataCopy.localidad = null;
        this.setState({
          formData: formDataCopy,
          provincias: [],
          localidades: []
        }, () => {
          this.setState({ provinciasLoading: true });
          this.ajaxHandler.getJson('/provincias/' + object.value + '/select')
          .then((data) => {
            this.setState({
              provincias: data
            }, () => resolve());
          }).finally(() => {
            this.setState({ provinciasLoading: false });
          });
        });
      } else {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.pais = null;
        formDataCopy.provincia = null;
        formDataCopy.localidad = null;
        this.setState({
          formData: formDataCopy,
          provincias: [],
          localidades: []
        }, () => resolve());
      }
    });
  }

  handleProvinciaChange(object) {
    return new Promise((resolve, reject) => {
      if(object) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.provincia = { id: object.value, label: object.label };
        formDataCopy.localidad = null;
        this.setState({
          formData: formDataCopy,
          localidades: []
        }, () => {
          this.setState({ localidadesLoading: true });
          this.ajaxHandler.getJson('/localidades/' + object.value + '/select')
          .then((data) => {
            this.setState({
              localidades: data
            }, () => resolve());
          }).finally(() => {
            this.setState({ localidadesLoading: false });
          });
        });
      } else {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.provincia = null;
        formDataCopy.localidad = null;
        this.setState({
          formData: formDataCopy,
          localidades: []
        }, () => resolve());
      }
    });
  }

  handleLocalidadChange(object) {
    return new Promise((resolve, reject) => {
      if(object) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.localidad = { id: object.value, label: object.label };
        this.setState({
          formData: formDataCopy
        }, () => resolve());
      } else {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.localidad = null;
        this.setState({
          formData: formDataCopy
        }, () => resolve());
      }
    });
  }


  handleRegionChange(name, object) {
    Promise.all([
      this.getData('subregiones', object.id)
		]).then((data) => {
      let subregiones = data[0];
			this.setState({
        subregiones: subregiones
      });
      this.handleSelectFormChange(name, object);
		}).catch(function(error) {
			// TODO: Manejo de errores
			console.log(error);
    });
  }



  handleEstadoChange(activo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy['activo'] = activo;
		this.setState({
			formData: formDataCopy
    });
  }

  handleEnviaAlertaChange(activo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy['envia_alerta'] = activo;
		this.setState({
			formData: formDataCopy
    });
  }

  handleEsUsuarioChange(esUsuario) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy['esUsuario'] = esUsuario;
    this.setState({
			formData: formDataCopy
		});
  }

  handleNotificacionesActivasChange(notificacionesActivas) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.usuario['notificacionesActivas'] = notificacionesActivas;
		this.setState({
      formData: formDataCopy
    });
  }

	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});
  }

	handleChangeDireccion(keyDireccion, valueDireccion, direccionValid){
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[keyDireccion] = valueDireccion;
    formDataCopy['direccionValid'] = direccionValid;
		this.setState({
			formData: formDataCopy
		});

	}

	handleBasesChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.usuario[name] = value;
		this.setState({
			formData: formDataCopy
		});
  }


  handleUsuarioFormChange(event){
    const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

    //TODO: CHEQUEAR QUE EL USUARIO SEA ÜNICO LO MISMO CON EL NRO. DE LEGAJO
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.usuario[name] = value;
		this.setState({
			formData: formDataCopy
		});
  }

  handleSelectFormChange(name, object) {

   let value = object === null ? null : object.id;

   if(this.state.props.action === 'EDIT') {
      if ( name === "localidad") {
          value = object.value;
      }

   }

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});
    console.log(this.state.formData);
  }

  handlePerfilChange(name, perfil) {
    const value = perfil === null ? null : perfil.id;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.usuario[name] = value;
		this.setState({
			formData: formDataCopy
		}, () => {
      if(perfil){
        perfil.permisos.includes('USUARIO_POSEER_MOVIL') ? this.setState({ hasPermisoMovil : true }) : this.setState({ hasPermisoMovil : false });
        perfil.permisos.includes('USUARIO_ACTUAR_COMO_GERENCIADOR') ? this.setState({ hasPermisoGerenciador : true }) : this.setState({ hasPermisoGerenciador : false });
        perfil.permisos.includes('USUARIO_TRABAJAR_BASES') ? this.setState({ hasPermisoBases : true }) : this.setState({ hasPermisoBases : false });
      }
		});
  }

  handleMovilChange(name, movil) {
    const value = movil === null ? null : movil.id;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.usuario[name] = value;
		this.setState({
			formData: formDataCopy
		});
  }

  handleGerenciadorChange(name, gerenciador) {
   /* const value = gerenciador === null ? null : gerenciador.id;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.usuario[name] = value;
		this.setState({
			formData: formDataCopy
		});*/
  }

  handleDatePickerFormChange(name, event) {
    let date = event ? event.format(): '';
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = date;
		this.setState({
			formData: formDataCopy
		});
  }

  // VEC-3947: el subconjunto de ítems por servicio solo se configura donde la mano de obra sale de ítems.
  itemsPorServicioHabilitado() {
    return ConfigBusiness.get('servicios.proveedores.habilitado') === 'true'
      && ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true';
  }

  // VEC-4382: importar / exportar por planilla los servicios y los ítems por servicio. En la edición trabajan sobre
  // lo GUARDADO del proveedor (no ven los cambios del formulario que todavía no se guardaron). En el alta no hay nada
  // guardado: trabajan sobre lo que tiene el formulario, no escriben nada y lo que importan se guarda con el proveedor.
  renderBotonesPlanilla(tipo) {
    // También en el alta (VEC-4382): ahí trabajan sobre lo que tiene el formulario, que se guarda con el proveedor.
    if (this.props.action !== 'EDIT' && this.props.action !== 'ADD') return null;
    const items = tipo === 'items';
    // Los botones de import / export de las demás grillas (src/commons/grid/GridToolbar.jsx): en este sistema
    // importar lleva `ft-download` y exportar `ft-upload`.
    return (
      <div className="text-right ml-1" style={{ whiteSpace: 'nowrap' }}>
        <GridToolbar>
          <GridToolbarButton
            id={'planilla_importar_' + tipo}
            icon="ft-download"
            messageId={items ? 'gerenciadoresAbm.planilla.importar_items' : 'gerenciadoresAbm.planilla.importar_servicios'}
            label={items ? 'Importar ítems por servicio desde una planilla' : 'Importar servicios desde una planilla'}
            onClick={() => this.setState({ planillaModal: tipo })}
          />
          <GridToolbarButton
            id={'planilla_exportar_' + tipo}
            icon="ft-upload"
            messageId={items ? 'gerenciadoresAbm.planilla.exportar_items' : 'gerenciadoresAbm.planilla.exportar_servicios'}
            label={items ? 'Exportar ítems por servicio a una planilla' : 'Exportar servicios a una planilla'}
            onClick={() => this.exportarPlanilla(tipo)}
          />
        </GridToolbar>
      </div>
    );
  }

  exportarPlanilla(tipo) {
    const enAlta = this.props.action === 'ADD';
    const descarga = enAlta
      ? Utils.dataBlob('/gerenciadores/nuevo/' + tipo + '/exportar', 'POST', this.datosDelFormularioParaPlanilla())
      : Utils.dataBlob('/gerenciadores/' + this.state.formData.id + '/' + tipo + '/exportar', 'GET', {});
    descarga
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        // dataBlob devuelve el nombre tal como viene del header, con las comillas incluidas.
        link.setAttribute('download', String(res.filename).replace(/"/g, ''));
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {}); // Utils.dataBlob ya mostró el error.
  }

  // Lo que el alta le manda al backend para que la planilla parta de lo que el usuario ya eligió.
  datosDelFormularioParaPlanilla() {
    return {
      servicios: this.state.formData.servicios || [],
      serviciosItems: this.state.formData.serviciosItems || {},
    };
  }

  // Alta: después de importar el formulario tiene que mostrar lo que devolvió el backend (no hay nada guardado que
  // recargar). Importar servicios reemplaza los servicios elegidos; importar ítems, los ítems elegidos por servicio.
  aplicarImportadoEnAlta(datos) {
    return new Promise((resolve, reject) => {
      const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
      if (datos.servicios) {
        formDataCopy.servicios = datos.servicios;
        // Igual que al quitar un servicio con el listbox: sus ítems elegidos se descartan.
        const serviciosItems = {};
        Object.keys(formDataCopy.serviciosItems || {}).forEach((servicioId) => {
          if (formDataCopy.servicios.indexOf(servicioId) !== -1) serviciosItems[servicioId] = formDataCopy.serviciosItems[servicioId];
        });
        formDataCopy.serviciosItems = serviciosItems;
      }
      if (datos.serviciosItems) formDataCopy.serviciosItems = datos.serviciosItems;
      // Primero el nombre y el tipo de los ítems importados y recién después el formulario: si la consulta falla no se
      // aplica nada (la promesa se rechaza y el modal lo avisa), en vez de mostrar como "Todos los ítems" una
      // selección restringida que sí viajaría al guardar.
      const nombres = datos.serviciosItems && this.itemsPorServicioHabilitado()
        ? this.cargarNombresDeItems(formDataCopy.serviciosItems)
        : Promise.resolve();
      nombres.then(() => {
        this.setState({ formData: formDataCopy }, () => {
          $(this.refs.duallistboxservicios).bootstrapDualListbox('refresh', true);
          resolve();
        });
      }, reject);
    });
  }

  // Después de importar, el formulario tiene que mostrar lo que quedó guardado: servicios asignados e ítems por
  // servicio. Los demás campos (que pueden tener cambios sin guardar) no se tocan.
  // Devuelve una promesa que se resuelve cuando el formulario ya muestra lo guardado y se rechaza si no se pudo:
  // el modal de importación espera a que esto termine antes de informar el resultado, y mientras falle el
  // guardado queda bloqueado (handleSubmit), porque enviaría los servicios / ítems viejos y desharía la importación.
  recargarServiciosDelProveedor() {
    return this.ajaxHandler.getJson('/gerenciadores/' + this.state.formData.id)
      .then((guardado) => new Promise((resolve, reject) => {
        if (!guardado) {
          reject(new Error('Proveedor sin datos'));
          return;
        }
        const formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy.servicios = guardado.servicios;
        formDataCopy.serviciosItems = guardado.serviciosItems;
        this.setState({ formData: formDataCopy, serviciosDesactualizados: false }, () => {
          $(this.refs.duallistboxservicios).bootstrapDualListbox('refresh', true);
          // El nombre y el tipo de los ítems tienen que estar antes de dar la recarga por buena (si no, el combo los
          // muestra como "Todos los ítems"): si falla, la recarga falla y el guardado queda bloqueado.
          const nombres = guardado.serviciosItems && this.itemsPorServicioHabilitado()
            ? this.cargarNombresDeItems(guardado.serviciosItems)
            : Promise.resolve();
          nombres.then(resolve, reject);
        });
      }))
      .catch((error) => {
        this.setState({ serviciosDesactualizados: true });
        throw error; // AjaxHandler ya mostró el error de red, si lo hubo.
      });
  }

  registrarNombresDeItems(opciones) {
    if (!opciones.length) return;
    this.setState((prev) => {
      const nombres = Object.assign({}, prev.nombresDeItems);
      const tipos = Object.assign({}, prev.tiposDeItems);
      opciones.forEach((opcion) => {
        nombres[opcion.value] = opcion.label;
        tipos[opcion.value] = opcion.tipo;
      });
      return { nombresDeItems: nombres, tiposDeItems: tipos };
    });
  }

  // El catálogo tiene el tipo con distinto casing ('PRODUCTO', 'Mano de obra'): se guarda el de las columnas.
  opcionDeItem(item) {
    const esProducto = !!item.tipo && item.tipo.toLowerCase() === ITEM_TIPO_PRODUCTO.toLowerCase();
    const tipo = esManoDeObra(item.tipo) ? ITEM_TIPO_MANO_DE_OBRA : (esProducto ? ITEM_TIPO_PRODUCTO : item.tipo);
    return { value: item.id, label: item.descripcion, tipo: tipo };
  }

  // Columnas de la tabla: Repuestos solo si el entorno trabaja con repuestos (como la herencia de ítems).
  tiposDeItemPorServicio() {
    const tipos = [];
    if (ConfigBusiness.get('tickets.trabajaConRepuestos.habilitado') === 'true') {
      tipos.push({ tipo: ITEM_TIPO_PRODUCTO, titulo: this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.table_column_repuestos', defaultMessage: 'Repuestos' }) });
    }
    tipos.push({ tipo: ITEM_TIPO_MANO_DE_OBRA, titulo: this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.table_column_mano_de_obra', defaultMessage: 'Mano de Obra' }) });
    return tipos;
  }

  // Los elegidos del servicio que son de un tipo. Los de tipo todavía desconocido (nombres sin cargar) no se
  // muestran en ninguna columna, pero se conservan al editar la otra (handleServicioItemsChange).
  itemsDelTipo(seleccionados, tipo) {
    return seleccionados.filter((itemId) => this.state.tiposDeItems[itemId] === tipo);
  }

  // Devuelve una promesa que se rechaza si falla alguna consulta (AjaxHandler ya mostró el error): sin el nombre y el
  // tipo de un ítem elegido el combo no lo muestra y parece "Todos los ítems" aunque al guardar viaje restringido.
  // Quien lo necesite resuelto (después de importar) la espera; los demás la ignoran con catch.
  cargarNombresDeItems(serviciosItems) {
    return Promise.all(Object.keys(serviciosItems).map((servicioId) => {
      const ids = serviciosItems[servicioId] || [];
      if (!ids.length) return Promise.resolve();
      return Promise.resolve(this.ajaxHandler.getJson('/items/items-de-servicio/' + servicioId + '?ids=' + ids.join(',')))
        .then((items) => this.registrarNombresDeItems((items || []).map((item) => this.opcionDeItem(item))));
    }));
  }

  // Búsqueda del lado del servidor: hay servicios con cientos de ítems. El combo la pide al montarse con el texto
  // vacío (así la página visible ya tiene sus opciones al abrir) y en cada tecla; el resultado queda en
  // cacheBusquedaItems y no se vuelve a pedir. Cada columna busca solo los ítems de su tipo. Un fallo no se cachea: la próxima búsqueda reintenta.
  // No hace setState: re-renderizar el ABM mientras se tipea le borraría el texto al combo. Los nombres de los
  // elegidos se registran al elegir (handleServicioItemsChange) y al abrir (cargarNombresDeItems).
  buscarItemsDeServicio(servicioId, tipo, texto) {
    const combo = servicioId + '|' + tipo;
    const clave = combo + '|' + texto;
    if (this.busquedasEnCurso[clave]) return this.busquedasEnCurso[clave];
    const cache = this.cacheBusquedaItems[combo];
    const url = '/items/items-de-servicio/' + servicioId + '?limite=' + LIMITE_BUSQUEDA_ITEMS + '&tipoItem=' + encodeURIComponent(tipo)
      + (texto ? '&q=' + encodeURIComponent(texto) : '');
    this.busquedasEnCurso[clave] = this.ajaxHandler.getJson(url)
      .then((items) => ({ options: (items || []).map((item) => this.opcionDeItem(item)) }))
      .catch(() => {
        // AjaxHandler ya mostró el error. El combo cachea lo que devolvemos: se borra para que no quede vacío.
        setTimeout(() => { delete cache[texto]; }, 0);
        return { options: [] };
      })
      .finally(() => { delete this.busquedasEnCurso[clave]; });
    return this.busquedasEnCurso[clave];
  }

  // Mismo array mientras no cambien los elegidos ni sus nombres (ver valoresDeCombos).
  valorDelCombo(combo, seleccionados) {
    // Con el tipo: el combo devuelve estos mismos objetos en onChange y registrarNombresDeItems los vuelve a anotar.
    const valor = seleccionados.map((itemId) => ({ value: itemId, label: this.state.nombresDeItems[itemId] || String(itemId), tipo: this.state.tiposDeItems[itemId] }));
    const clave = valor.map((opcion) => opcion.value + ':' + opcion.label).join('|');
    const memo = this.valoresDeCombos[combo];
    if (memo && memo.clave === clave) return memo.valor;
    this.valoresDeCombos[combo] = { clave, valor };
    return valor;
  }

  labelDeServicio(servicioId) {
    const servicio = this.state.serviciosDisponibles.find((element) => element.value == servicioId);
    return servicio ? servicio.label : String(servicioId);
  }

  // Lo que muestra la tabla "Ítems por servicio": orden, filtro y página. Lo usan el render y la precarga.
  paginaItemsPorServicio() {
    const servicios = this.state.formData.servicios || [];
    // Mismo orden que el dual listbox (el de serviciosDisponibles): formData.servicios viene por id al abrir
    // y en el orden del dual listbox después de editar, y la tabla no tiene que cambiar de orden entre una y otra.
    const posicion = (servicioId) => {
      const i = this.state.serviciosDisponibles.findIndex((element) => element.value == servicioId);
      return i === -1 ? Number.MAX_SAFE_INTEGER : i;
    };
    const ordenados = servicios.slice().sort((a, b) => posicion(a) - posicion(b));
    // Filtro rápido: los servicios elegidos (sin elegir, todos). Se cruza con los asignados por si alguno
    // elegido se quitó del dual listbox.
    const filtro = this.state.itemsPorServicioFiltro.filter((servicioId) => servicios.indexOf(servicioId) !== -1);
    const filtrados = filtro.length ? ordenados.filter((servicioId) => filtro.indexOf(servicioId) !== -1) : ordenados;
    const porPagina = this.state.itemsPorServicioPorPagina;
    // Si se quitan servicios o cambia el filtro, la página puede quedar fuera de rango.
    const pagina = Math.min(this.state.itemsPorServicioPagina, Math.max(0, Math.ceil(filtrados.length / porPagina) - 1));
    const visibles = filtrados.slice(pagina * porPagina, (pagina + 1) * porPagina);
    return { ordenados, filtro, filtrados, porPagina, pagina, visibles };
  }

  // El multiselect tiene alto fijo y los chips que no entran quedan abajo: al agregar uno se centra el último
  // chip en el control para que se vea lo que se acaba de elegir. No se va al fondo porque detrás del último
  // chip está el input de búsqueda, que suele caer solo en un renglón vacío. Al quitar no se mueve.
  scrollAlUltimoChip(clave, cantidadAntes, cantidadDespues) {
    const contenedor = this.contenedoresMultiselect[clave];
    const chips = contenedor && contenedor.querySelector('.Select-multi-value-wrapper');
    const valores = chips ? chips.querySelectorAll('.Select-value') : [];
    if (!valores.length || cantidadDespues <= cantidadAntes) return;
    const ultimo = valores[valores.length - 1];
    // Los dos offsetTop son relativos al .Select-control (position: relative).
    const arribaDelChip = ultimo.offsetTop - chips.offsetTop;
    chips.scrollTop = arribaDelChip - (chips.clientHeight - ultimo.offsetHeight) / 2;
  }

  // serviciosItems lleva los ítems de los dos tipos juntos ({servicioId: [itemIds]}): el tipo sale del ítem.
  // Cada columna reemplaza solo los de su tipo. Sin ítems de un tipo, el proveedor brinda todos los de ese
  // tipo; sin ninguno, el servicio no viaja en serviciosItems.
  handleServicioItemsChange(servicioId, tipo, seleccionados) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    let serviciosItems = Object.assign({}, formDataCopy.serviciosItems);
    const actuales = serviciosItems[servicioId] || [];
    const elegidos = seleccionados || [];
    this.registrarNombresDeItems(elegidos);
    const items = actuales.filter((itemId) => this.state.tiposDeItems[itemId] !== tipo)
      .concat(elegidos.map((opcion) => opcion.value));
    if (items.length) {
      serviciosItems[servicioId] = items;
    } else {
      delete serviciosItems[servicioId];
    }
    formDataCopy.serviciosItems = serviciosItems;
    const combo = servicioId + '|' + tipo;
    const cantidadAntes = this.itemsDelTipo(actuales, tipo).length;
    this.setState({ formData: formDataCopy },
      () => this.scrollAlUltimoChip(combo, cantidadAntes, elegidos.length));
  }

  renderItemsPorServicio() {
    const formData = this.state.formData;
    if (!this.itemsPorServicioHabilitado() || !formData.servicios || !formData.servicios.length) return null;
    const serviciosItems = formData.serviciosItems || {};
    const todos = this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.placeholder_todos_los_items', defaultMessage: 'Todos los ítems' });
    const labelDeServicio = (servicioId) => this.labelDeServicio(servicioId);
    const { ordenados, filtro, filtrados, porPagina, pagina, visibles } = this.paginaItemsPorServicio();
    const tipos = this.tiposDeItemPorServicio();
    // Servicio y una columna por tipo, a partes iguales.
    const anchoColumna = (100 / (tipos.length + 1)) + '%';
    return (
      <div className="row">
        <div className="col-md-9">
          <div className="form-group row">
            <label className="col-md-2 label-control col-form-label">
              <FormattedMessage id="gerenciadoresAbm.render.services.label_items_por_servicio" defaultMessage="Ítems por servicio:"/>
            </label>
            {/* Mismo ancho que la tabla de Servicios: en vista es col-md-6, en edición el duallist ocupa col-md-10. */}
            <div className={this.props.action === 'VIEW' ? 'col-md-6' : 'col-md-10'}>
              <p className="text-muted">
                <FormattedMessage id="gerenciadoresAbm.render.services.ayuda_items_por_servicio_y_tipo" defaultMessage="Sin ítems seleccionados en una columna, el proveedor brinda todos los ítems de ese tipo del servicio."/>
              </p>
              <div className="d-flex align-items-start mb-1">
              <div style={{ flex: '1 1 auto', minWidth: 0 }} ref={(el) => { this.contenedoresMultiselect.filtro = el; }}>
                <Select
                  multi
                  className="select-una-linea"
                  name="itemsPorServicioFiltro"
                  placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.filtro_servicio', defaultMessage: 'Filtrar por servicio' })}
                  options={ordenados.map((servicioId) => ({ value: servicioId, label: labelDeServicio(servicioId) }))}
                  value={filtro}
                  onChange={(elegidos) => {
                    const cantidadAntes = filtro.length;
                    this.setState({ itemsPorServicioFiltro: (elegidos || []).map((opcion) => opcion.value), itemsPorServicioPagina: 0 },
                      () => this.scrollAlUltimoChip('filtro', cantidadAntes, (elegidos || []).length));
                  }}
                />
              </div>
              {this.renderBotonesPlanilla('items')}
              </div>
              {/* Ancho fijo: los combos de una línea no tienen que ensanchar la tabla al elegir ítems. */}
              <table className="table table-bordered" style={{ tableLayout: 'fixed' }}>
                <colgroup>
                  <col style={{ width: anchoColumna }}/>
                  {tipos.map(({ tipo }) => <col key={tipo} style={{ width: anchoColumna }}/>)}
                </colgroup>
                <thead className="thead-fleet">
                  <tr>
                    <th scope="col"><FormattedMessage id="gerenciadoresAbm.render.services.table_column_servicio" defaultMessage="Servicio"/></th>
                    {tipos.map(({ tipo, titulo }) => <th scope="col" key={tipo}>{titulo}</th>)}
                  </tr>
                </thead>
                <tbody>
                {visibles.map((servicioId) => {
                  const seleccionados = serviciosItems[servicioId] || [];
                  return (
                    <tr key={servicioId}>
                      {/* Ancho fijo: un nombre largo se trunca con "..." y se lee entero en el tooltip. */}
                      <td className="align-middle" title={labelDeServicio(servicioId)} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {labelDeServicio(servicioId)}
                      </td>
                      {tipos.map(({ tipo }) => {
                        const combo = servicioId + '|' + tipo;
                        const delTipo = this.itemsDelTipo(seleccionados, tipo);
                        this.cacheBusquedaItems[combo] = this.cacheBusquedaItems[combo] || {};
                        return (
                          <td key={tipo}>
                            {this.props.action === 'VIEW' ? (
                              delTipo.length ? delTipo.map((itemId) => this.state.nombresDeItems[itemId] || itemId).join(', ') : todos
                            ) : (
                              <div ref={(el) => { this.contenedoresMultiselect[combo] = el; }}>
                                <Select.Async
                                  multi
                                  className="select-una-linea"
                                  name={'serviciosItems_' + servicioId + '_' + tipo}
                                  placeholder={todos}
                                  cache={this.cacheBusquedaItems[combo]}
                                  loadOptions={(texto) => this.buscarItemsDeServicio(servicioId, tipo, texto)}
                                  filterOptions={(opciones) => opciones}
                                  loadingPlaceholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.items_cargando', defaultMessage: 'Cargando...' })}
                                  searchPromptText={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.items_escribi_para_buscar', defaultMessage: 'Escribí para buscar' })}
                                  noResultsText={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.services.items_sin_resultados', defaultMessage: 'Sin resultados' })}
                                  value={this.valorDelCombo(combo, delTipo)}
                                  onChange={(opcionesElegidas) => this.handleServicioItemsChange(servicioId, tipo, opcionesElegidas)}
                                />
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
                </tbody>
              </table>
              {filtrados.length > 5 && (
                <GridPagination
                  count={filtrados.length}
                  page={pagina}
                  perPage={porPagina}
                  rowsPerPageOptions={[5, 10, 25]}
                  onPageChange={(e, nuevaPagina) => this.setState({ itemsPorServicioPagina: nuevaPagina })}
                  onPerPageChange={(e) => this.setState({ itemsPorServicioPorPagina: parseInt(e.target.value, 10), itemsPorServicioPagina: 0 })}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleDatePickerFormRawChange(name, date) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = date;
		this.setState({
			formData: formDataCopy
		});
  }

  handleNuevoDatosComerciales = (e) => {
    e.preventDefault();
    this.setState(prev => ({
      showModalDatosComerciales: true,
      modalDatosComercialesKey: prev.modalDatosComercialesKey + 1,
      editDatosComerciales: null,
    }));
  };

  handleCloseDatosComerciales = () => {
    this.setState({ showModalDatosComerciales: false });
  };

  handleSaveDatosComerciales = (data) => {
    if (this.state.formData.id) {
      this.fetchDatosComerciales(this.state.formData.id);
    }
    this.setState({ showModalDatosComerciales: false });
  };

  fetchDatosComerciales = (gerenciadorId) => {
    this.ajaxHandler.fetch(`/gerenciadores/${gerenciadorId}/datos-bancarios`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ datosComerciales: data || [] });
      })
      .catch(() => {
        this.setState({ datosComerciales: [] });
      });
  }
  
  handleDeleteDatosComerciales = (datoId) => {
    const gerenciadorId = this.state.formData.id;
    swal({
      title: this.props.intl.formatMessage({ id: 'gerenciadoresGrid.modal_delete.confirm_eliminacion', defaultMessage: '¿Confirma la eliminación?' }),
      icon: "warning",
      buttons: {
        confirm: {
          text: this.props.intl.formatMessage({ id: 'gerenciadoresGrid.modal_delete.confirm_eliminacion.si', defaultMessage: 'Si' }),
          value: true,
          visible: true,
          className: "btn btn-primary",
          closeModal: false
        },
        cancel: {
          text: this.props.intl.formatMessage({ id: 'gerenciadoresGrid.modal_delete.confirm_no', defaultMessage: 'No' }),
          value: null,
          visible: true,
          className: "btn btn-danger",
          closeModal: true,
        }
      }
    })
      .then((isConfirm) => {
        if (isConfirm) {
          this.ajaxHandler.fetch(`/gerenciadores/${gerenciadorId}/datos-bancarios/${datoId}`, {
            method: 'DELETE',
          })
            .then(response => {
              if (response.status === 204) {
                this.fetchDatosComerciales(gerenciadorId);
                swal(this.props.intl.formatMessage({ id: 'gerenciadoresGrid.modal_delete.information_eliminado', defaultMessage: 'Eliminado!' }), "", "success");
              } else {
                swal(this.props.intl.formatMessage({ id: 'gerenciadoresGrid.modal_delete.information_error', defaultMessage: 'No se pudo eliminar el dato bancario.' }), "", "error");
              }
            })
            .catch(() => {
              swal(this.props.intl.formatMessage({ id: 'gerenciadoresGrid.modal_delete.information_error', defaultMessage: 'No se pudo eliminar el dato bancario.' }), "", "error");
            });
        }
      });
  };

  handleEditDatosComerciales = (row) => {
    this.setState(prev => ({
      showModalDatosComerciales: true,
      modalDatosComercialesKey: prev.modalDatosComercialesKey + 1,
      editDatosComerciales: row,
    }));
  };

  /** VEC-3499 Sc. 04: el selector depende solo de su flag; cambiarlo exige además TARIFARIOS_MODIFICAR. */
  tarifariosHabilitado() {
    return ConfigBusiness.get('tarifarios.habilitado') === 'true';
  }

  puedeCambiarTarifario() {
    return this.tarifariosHabilitado()
      && (this.props.action === 'ADD' || this.props.action === 'EDIT')
      && Security.hasPermission('TARIFARIOS_MODIFICAR');
  }

  /**
   * Si el proveedor ya tenía un tarifario y se eligió otro, se pide confirmación (mismo popup que
   * desde el ABM del tarifario). Sacarlo o elegir uno cuando no tenía no pregunta.
   */
  confirmarCambioDeTarifario() {
    const original = this.state.tarifarioOriginal;
    const nuevoId = this.state.formData.tarifarioId;
    if (!this.puedeCambiarTarifario() || !original || !nuevoId || nuevoId === original.id) {
      return Promise.resolve(true);
    }
    const nuevo = this.state.tarifarios.find((t) => t.value === nuevoId);
    const escapar = (texto) => $('<div>').text(texto || '').html();
    return Swal.fire({
      title: this.props.intl.formatMessage({ id: 'inventarioTarifarios.reasignar.titulo', defaultMessage: '¿Confirma el cambio de tarifario?' }),
      html: this.props.intl.formatMessage(
        {
          id: 'inventarioTarifarios.reasignar.detalle',
          defaultMessage: 'El proveedor {proveedor} ya tiene asociado el tarifario {anterior}. Pasará a utilizar {nuevo}.',
        },
        {
          proveedor: '<b>' + escapar(this.state.formData.razon_social) + '</b>',
          anterior: '<b>' + escapar(original.nombre) + '</b>',
          nuevo: '<b>' + escapar(nuevo ? nuevo.label : '') + '</b>',
        }
      ),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0ABFBC',
      cancelButtonColor: '#d33',
      confirmButtonText: this.props.intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' }),
      cancelButtonText: this.props.intl.formatMessage({ id: 'Cancelar', defaultMessage: 'Cancelar' }),
    }).then((result) => !!result.value);
  }

	handleSubmit(event) {
    event.preventDefault();
    if (this.state.serviciosDesactualizados) {
      Swal.fire(
        this.props.intl.formatMessage({ id: 'gerenciadorPlanilla.error_sincronizar', defaultMessage: 'La planilla se importó, pero no se pudo actualizar la pantalla. Recargue la página antes de guardar, para no deshacer lo importado.' }),
        ' ',
        'warning'
      );
      return;
    }
    this.confirmarCambioDeTarifario().then((confirmado) => {
      if (confirmado) this.guardar();
    });
	}

	guardar() {
    this.setState({ loading: true });
    let component = this
		this.ajaxHandler.fetch('/gerenciadores' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
      method: this.props.action === 'ADD' ? 'POST' : 'PUT',
      // silent: el 409 (razón social duplicada) se muestra inline; para el resto de errores
      // se reproduce abajo el manejo que hacía AjaxHandler sin silent.
      silent: true,
      body: JSON.stringify({
        ...this.state.formData,
        cuit: normalizarCuit(this.state.formData.cuit)
      }),
    }).then(response => {
      if(response.status !== 400) {

        component.exit();
      } else {
        response.json()
        .then(data => {
          this.setState({
            errors: data.detalle
          });
        });
      }
      window.scrollTo(0,0);
    }, (error) => {
      const resultado = resolverErrorGuardado(error && error.status);
      if(resultado.inline) {
        this.setState({ errors: resultado.errors });
        window.scrollTo(0,0);
        return;
      }
      // Mismo comportamiento que sin silent: popup de error interno (status >= 404, salvo 409)
      // o popup de error de red (sin status), y luego el handleError del caller.
      if(error && error.status >= 404) {
        component.ajaxHandler.handleResponseErrorsIsValid({ status: error.status }, false);
      } else if(error && error.status === undefined) {
        component.ajaxHandler.handleError(error);
      }
      component.ajaxHandler.handleError(error);
    }).catch((error) => {
      component.ajaxHandler.handleError(error);
    }).finally(() => {
      this.setState({ loading: false });
    });
	}

	handleCancel(event) {
		this.exit();
	}

	exit() {
		this.setState({
			redirectTo: '/gerenciadores'
		});
	}

	render() {
        this.formValidation.validate();
		let formData = this.state.formData;
        let validationState = this.formValidation.state;
        let state = this.state;
        const puedeVerDatosComerciales = this.state.props.action === 'EDIT' || this.state.props.action === 'VIEW';
        const puedeEditarDatosComerciales = this.state.props.action === 'EDIT';
        const serviciosHabilitado = ConfigBusiness.get('servicios.proveedores.habilitado') === 'true';
		return (
			<React.Fragment>
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				    {this.state.loading && <Loading />}
			        <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
                                {this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
                            </div>
                            <form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
                            <div className="form-body">
                                <div className="card pull-up">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <h4 className="form-section">
                                                <i className="icon-home"></i><FormattedMessage id="gerenciadoresAbm.render.general_data.header_datos_generales" defaultMessage=" Datos Generales "/><div className="float-right" style={{fontSize:'14px'}}><FormattedMessage id="gerenciadoresAbm.render.general_data.campos_requeridos" defaultMessage="* campos requeridos"/></div>
                                            </h4>
                                            <div className="row">
                                                {/* Gerenciador */}
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label className="col-md-3 label-control col-form-label" htmlFor="razon_social">
                                                            <FormattedMessage id="gerenciadoresAbm.render.general_data.label_gerenciador" defaultMessage="Gerenciador *:"/>
                                                        </label>
                                                        <div className="col-md-9">
                                                            {this.props.action === 'VIEW' ? (
                                                            <div className="form-control-static col-form-label form-value">{formData.razon_social}</div>
                                                            ) : (
                                                            <div>
                                                                <input type="text" className="form-control" id="razon_social" name="razon_social" placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.general_data.placeholder_gerenciador', defaultMessage: 'Gerenciador' })} value={formData.razon_social} onChange={this.handleInputFormChange} />
                                                                <div className="help-block text-danger field-message" hidden={validationState.formData.razon_social.pristine || validationState.formData.razon_social.valid}>{validationState.formData.razon_social.message}</div>
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {/* Número de registro */}
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label className="col-md-3 label-control col-form-label" htmlFor="cuit">
                                                            <FormattedMessage id="gerenciadoresAbm.render.general_data.label_numero_registro" defaultMessage="Número de registro:"/>
                                                        </label>
                                                        <div className="col-md-9">
                                                            {this.props.action === 'VIEW' ? (
                                                            <div className="form-control-static col-form-label form-value">{formData.cuit}</div>
                                                            ) : (
                                                            <div>
                                                                <input type="text" className="form-control" id="cuit" name="cuit" maxLength={50} placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.general_data.placeholder_numero_registro', defaultMessage: 'Número de registro' })} value={formData.cuit === null || formData.cuit === undefined ? '' : formData.cuit} onChange={this.handleInputFormChange} />
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {/* TIPOS */}
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label className="col-md-3 label-control col-form-label" htmlFor="tipo">
                                                            <FormattedMessage id="gerenciadoresAbm.render.general_data.label_tipo:" defaultMessage="Tipo:"/> *
                                                        </label>
                                                        <div className="col-md-9">
                                                            <div>
                                                                <Select
                                                                id="tipo"
                                                                name="tipo"
                                                                disabled={this.state.props.action !== 'EDIT' && this.state.props.action !== 'ADD'}    
                                                                readOnly={this.state.props.action !== 'EDIT' && this.state.props.action !== 'ADD'}
                                                                placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.general_data.placeholder_tipo', defaultMessage: 'Tipo' })} 
                                                                options={this.state.tipos}
                                                                valueKey='id'
                                                                labelKey='nombre'
                                                                required
                                                                value={formData.tipo}
                                                                onChange={(e) => this.handleSelectFormChange("tipo", e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            {/* VEC-3499 Sc. 04: tarifario del proveedor. Sin TARIFARIOS_MODIFICAR se ve en solo lectura. */}
                                            {this.tarifariosHabilitado() && (
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label className="col-md-3 label-control col-form-label" htmlFor="tarifarioId">
                                                            <FormattedMessage id="gerenciadoresAbm.render.general_data.label_tarifario" defaultMessage="Tarifario:"/>
                                                        </label>
                                                        <div className="col-md-9">
                                                            {this.puedeCambiarTarifario() ? (
                                                            <div>
                                                                <Select
                                                                id="tarifarioId"
                                                                name="tarifarioId"
                                                                placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.general_data.placeholder_tarifario', defaultMessage: 'Sin tarifario (usa el Catálogo de Ítems)' })}
                                                                options={this.state.tarifarios}
                                                                valueKey='value'
                                                                labelKey='label'
                                                                value={formData.tarifarioId}
                                                                onChange={(opcion) => this.setState({ formData: { ...this.state.formData, tarifarioId: opcion ? opcion.value : null } })}
                                                                />
                                                            </div>
                                                            ) : (
                                                            <div className="form-control-static col-form-label form-value">
                                                                {formData.tarifarioNombre
                                                                  ? formData.tarifarioNombre
                                                                  : this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.general_data.sin_tarifario', defaultMessage: 'Sin tarifario (usa el Catálogo de Ítems)' })}
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            )}

                                            <div className="row">
                                                {/* SUBREGIONES */}
                                                <div className="col-md-9">
                                                    <div className="form-group row">
                                                        <label className="col-md-2 label-control col-form-label" htmlFor="subregiones">
                                                        <FormattedMessage id="gerenciadoresAbm.render.general_data.label_sub_regiones" defaultMessage="Sub Regiones *:"/>
                                                        </label>
                                                        {this.props.action === 'VIEW' ? (
                                                                <div className="col-md-6">
                                                                    {this.state.formData.subregiones && this.state.formData.subregiones.length ? (
                                                                    <div className="form-group row">
                                                                        <div className="col-md-12">
                                                                            <table className="table table-bordered">
                                                                            <thead className="thead-fleet subregiones">
                                                                                <tr>
                                                                                <th scope="col"><FormattedMessage id="gerenciadoresAbm.render.general_data.table_column_sub_regiones" defaultMessage="Subregiones"/></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {this.state.formData.subregiones.map((subr, index)=>{
                                                                                let sub = this.state.subRegionesDisponibles.find((element)=>element.id == subr);
                                                                                return(
                                                                                <tr key={index}>
                                                                                    <td className="align-middle">{sub.nombre}</td>
                                                                                </tr>
                                                                                );
                                                                            })}
                                                                            </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                        ) : (<p style={{marginTop:'10px'}}><FormattedMessage id="gerenciadoresAbm.render.general_data.no_cuenta_con_subregiones" defaultMessage="No cuenta con subregiones"/></p>)}
                                                                </div>) : (
                                                        <div className="col-md-10">
                                                            <div className="form-group">
                                                                <select multiple="multiple" size="10" ref="duallistbox"  value={formData.subregiones} readOnly>
                                                                    {this.state.subRegionesDisponibles.map(function(subregion) {
                                                                    return <option key={subregion.id} value={subregion.id}>{subregion.nombre}</option>;
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                {/* ESTADO */}
                                                <div className="col-md-6">
                                                    <div className="form-group row">
                                                        <label className="col-md-3 label-control col-form-label" htmlFor="activo">
                                                        <FormattedMessage id="gerenciadoresAbm.render.general_data.label_activo" defaultMessage="Activo:"/>
                                                        </label>
                                                        <div className="col-md-9">
                                                            <Switch
                                                                onChange={this.handleEstadoChange}
                                                                checked={formData.activo}
                                                                options={this.state.estados}
                                                                id="activo"
                                                                name="activo"
                                                                valueKey='id'
                                                                labelKey='nombre'
                                                                disabled={this.state.props.action === 'VIEW' ? true: false }
                                                                offColor="#FF4961"
                                                                onColor="#28D094"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                {serviciosHabilitado && (
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="ft-settings"></i><FormattedMessage id="gerenciadoresAbm.render.services.header_servicios" defaultMessage=" Servicios "/>
                      </h4>
                      <div className="row">
                        {/* SERVICIOS */}
                        <div className="col-md-9">
                          <div className="form-group row">
                            <label className="col-md-2 label-control col-form-label" htmlFor="servicios">
                              <FormattedMessage id="gerenciadoresAbm.render.services.label_servicios" defaultMessage="Servicios:"/>
                            </label>
                            {this.props.action === 'VIEW' ? (
                              <div className="col-md-6">
                                {this.state.formData.servicios && this.state.formData.servicios.length ? (
                                <div className="form-group row">
                                  <div className="col-md-12">
                                    <table className="table table-bordered">
                                      <thead className="thead-fleet">
                                        <tr>
                                          <th scope="col"><FormattedMessage id="gerenciadoresAbm.render.services.table_column_servicios" defaultMessage="Servicios"/></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      {this.state.formData.servicios.map((serv, index)=>{
                                        let s = this.state.serviciosDisponibles.find((element)=>element.value == serv);
                                        return(
                                        <tr key={index}>
                                          <td className="align-middle">{s ? s.label : serv}</td>
                                        </tr>
                                        );
                                      })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                ) : (<p style={{marginTop:'10px'}}><FormattedMessage id="gerenciadoresAbm.render.services.no_cuenta_con_servicios" defaultMessage="No cuenta con servicios"/></p>)}
                              </div>) : (
                            <div className="col-md-10">
                              {this.renderBotonesPlanilla('servicios')}
                              <div className="form-group">
                                <select multiple="multiple" size="10" ref="duallistboxservicios" value={formData.servicios} readOnly>
                                  {this.state.serviciosDisponibles.map(function(servicio) {
                                  return <option key={servicio.value} value={servicio.value}>{servicio.label}</option>;
                                  })}
                                </select>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {this.renderItemsPorServicio()}
                    </div>
                  </div>
                  {(this.props.action === 'EDIT' || this.props.action === 'ADD') && (
                    <GerenciadorPlanillaImportModal
                      open={!!this.state.planillaModal}
                      tipo={this.state.planillaModal || 'servicios'}
                      gerenciadorId={this.props.action === 'EDIT' ? this.state.formData.id : null}
                      gerenciadorNombre={this.state.formData.razon_social}
                      datosDelFormulario={() => this.datosDelFormularioParaPlanilla()}
                      onClose={() => this.setState({ planillaModal: null })}
                      onImportado={(datos) => (this.props.action === 'ADD' ? this.aplicarImportadoEnAlta(datos) : this.recargarServiciosDelProveedor())}
                    />
                  )}
                </div>
                )}


								<div className={this.state.formData.tipo != TIPO_GESTOR_ID ? 'hidden' : 'card pull-up'}>
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section mt-2">
                        <i className="ft-briefcase"></i><FormattedMessage id="gerenciadoresAbm.render.management_powers.header_poderes_gestion" defaultMessage=" Poderes de Gestión"/>
                      </h4>
	                    <div className="row">
													{/* Poderes */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="poderes">
																<FormattedMessage id="gerenciadoresAbm.render.management_powers.label_poderes" defaultMessage="Poderes:"/>
															</label>
															<div className="col-md-9">
																	<div className="form-group">
																		<select multiple="multiple" size="10" ref="duallistboxpoderes" value={formData.poderes}>
																			{this.state.poderesDisponibles.map(function(poder) {
																			return <option key={poder} value={poder}>{poder}</option>;
																			})}
																		</select>
																	</div>

															</div>
														</div>
													</div>
		                      {/* Titulares */}
		                      <div className="col-md-6">
		                        <div className="form-group row">
		                          <label className="col-md-3 label-control col-form-label" htmlFor="titulares">
														 		<FormattedMessage id="gerenciadoresAbm.render.management_powers.label_titulares" defaultMessage="Titulares:"/>
		                          </label>
		                          <div className="col-md-9">

																	<div className="form-group">
																		<select multiple="multiple" size="10" ref="duallistboxtitulares" value={formData.titulares}>
																			{this.state.titularesDisponibles.map(function(titular) {
																			return <option key={titular.id} value={titular.id}>{titular.nombre}</option>;
																			})}
																		</select>
																	</div>

		                          </div>
		                        </div>
		                      </div>
	                    </div>
                    </div>
                  </div>
                </div>


                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section mt-2">
                        <i className="ft-phone"></i><FormattedMessage id="gerenciadoresAbm.render.contact_details.header_datos_Contacto" defaultMessage=" Datos de Contacto"/>
                      </h4>

                      <div className="row">
                        {/* Contacto */}
                        <div className="col-md-6">

                          <div  className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="contacto">
                              <FormattedMessage id="gerenciadoresAbm.render.contact_details.label_contacto" defaultMessage="Contacto *:"/>
                            </label>
                            <div className="col-md-9">
                            {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.contacto}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="contacto" name="contacto" placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.contact_details.placeholder_contacto', defaultMessage: 'Contacto' })} value={formData.contacto} onChange={this.handleInputFormChange} />
                                <div className="help-block text-danger field-message" hidden={validationState.formData.contacto.pristine || validationState.formData.contacto.valid}>{validationState.formData.contacto.message}</div>
                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>



                      <div className="row">
                        {/* TELEFONO */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="telefono">
                              <FormattedMessage id="gerenciadoresAbm.render.contact_details.label_telefono" defaultMessage="Teléfono :"/>
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.telefono}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="telefono" name="telefono" placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.contact_details.placeholder_telefono', defaultMessage: 'Teléfono' })} value={formData.telefono} onChange={this.handleInputFormChange} />

                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="row">
                        {/* EMAIL */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="email">
                              <FormattedMessage id="gerenciadoresAbm.render.contact_details.label_email" defaultMessage="Email* :"/>
                            </label>
                            <div className="col-md-9">
                              {this.props.action === 'VIEW' ? (
                              <div className="form-control-static col-form-label form-value">{formData.email}</div>
                              ) : (
                              <div>
                                <input type="text" className="form-control" id="email" name="email" placeholder={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.render.contact_details.placeholder_email', defaultMessage: 'Email' })} value={formData.email} onChange={this.handleInputFormChange} />

                              </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {formData.tipo ? (
                      formData.tipo== 4 || formData.tipo.nombre === 'GPS' ? (
                      <div className="row">
                        {/* ENVIA ALERTA */}
                        <div className="col-md-6" >
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="envia_alerta">
                            <FormattedMessage id="gerenciadoresAbm.render.general_data.label_envia_alerta" defaultMessage="Enviar alerta de GPS:"/>
                            </label>
                            <div className="col-md-9">
                              <Switch
                                onChange={this.handleEnviaAlertaChange}
                                checked={formData.envia_alerta}
                                id="envia_alerta"
                                name="envia_alerta"
                                valueKey='id'
                                labelKey='nombre'
                                disabled={this.state.props.action === 'VIEW' ? true: false }
                                offColor="#FF4961"
                                onColor="#28D094"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      ) :null 
                      ) :''} 

                    </div>
                  </div>
                </div>

                {puedeVerDatosComerciales &&
                  (
                    <div className="card pull-up">
                      <div className="card-content">
                        <div className="card-body">
                          <h4 className="form-section mt-2">
                            <i className="fa fa-money"></i>
                            <FormattedMessage id="gerenciadoresAbm.render.contact_details.header_datos_comerciales_bancarios" defaultMessage=" Datos Comerciales y Bancarios" />
                          </h4>
                          <div class="float-right ticket-buttons">
                            {puedeEditarDatosComerciales && (
                              <a
                                href="#"
                                className="btn btn-float-sm btn-round btn-fleet ml-1"
                                data-tooltip="tooltip"
                                data-placement="top"
                                title=""
                                data-original-title="Nuevo"
                                onClick={this.handleNuevoDatosComerciales}
                              >
                                <i className="la la-plus align-middle"></i>
                              </a>
                            )}
                          </div>

                          {/* Grilla de datos comerciales y bancarios */}
                          <TableContainer>
                            <Table aria-label="comerciales table">
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell align="left">
                                    <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.column_nombre_comercial" defaultMessage="Nombre Comercial" />
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.column_id_cliente" defaultMessage="# ID Cliente" />
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.column_numero_cuenta" defaultMessage="Número de Cuenta" />
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.column_clave_interbancaria" defaultMessage="Clave Interbancaria" />
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.column_fecha_registro" defaultMessage="Fecha Registro" />
                                  </StyledTableCell>
                                  {puedeEditarDatosComerciales && (
                                    <StyledTableCell align="left">
                                      <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.column_acciones" defaultMessage="Acciones" />
                                    </StyledTableCell>
                                  )}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.datosComerciales.length === 0 ? (
                                  <TableRow>
                                    <StyledTableCell colSpan={6} align="center">
                                      <FormattedMessage id="gerenciadoresAbm.datos_bancarios_grid.no_data_table" defaultMessage="No se encontraron resultados..." />
                                    </StyledTableCell>
                                  </TableRow>
                                ) : (
                                  this.state.datosComerciales.map((row, idx) => (
                                    <TableRow key={idx}>
                                      <StyledTableCell align="left">
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <div>
                                            <div style={{ fontWeight: 600 }}>{row.nombre}</div>
                                          </div>
                                        </div>
                                      </StyledTableCell>
                                      <StyledTableCell align="left">{row.cliente_id}</StyledTableCell>
                                      <StyledTableCell align="left">{row.cuenta_nro}</StyledTableCell>
                                      <StyledTableCell align="left">{row.clave_interbancaria}</StyledTableCell>
                                      <StyledTableCell align="left">{LocaleFormat.formatDate(row.created_at)}</StyledTableCell>
                                      {puedeEditarDatosComerciales && (
                                        <StyledTableCell align="left">
                                          <button
                                            type="button"
                                            className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                                            title={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.datos_bancarios_grid.editar', defaultMessage: 'Editar' })}
                                            onClick={() => this.handleEditDatosComerciales(row)}
                                          >
                                            <i className="fa fa-pencil fa-xs"></i>
                                          </button>
                                          <button
                                            type="button"
                                            className="action delete btn btn-sm btn-icon btn-dt-grid text-danger"
                                            title={this.props.intl.formatMessage({ id: 'gerenciadoresAbm.datos_bancarios_grid.eliminar', defaultMessage: 'Eliminar' })}
                                            onClick={() => this.handleDeleteDatosComerciales(row.id)}
                                          >
                                            <i className="fa fa-trash fa-xs"></i>
                                          </button>
                                        </StyledTableCell>
                                      )}
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    </div>
                  )}

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body" id="container-direccion">
											<h4 className="form-section mt-2">
												<i className="ft-map-pin"></i><FormattedMessage id="gerenciadoresAbm.render.location_data.header_datos_ubicacion" defaultMessage=" Datos de Ubicación"/>
											</h4>
											<DireccionAutocompletar
												action={this.props.action}
												camposHidden={["codigoPostal"]}
												cambioDireccion={this.handleChangeDireccion}
												formulario={this.state.direccionForm}
                        localidadInteger={true}
												crearProvincias={true}
												camposObligatorios={[]}
                        crearLocalidades={true}
												/>

										</div>
									</div>
								</div>

                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        {this.props.action !== 'VIEW' && (
                        <button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid} >
                          <i className="fa fa-check-circle"></i><FormattedMessage id="gerenciadoresAbm.finish_button.guardar" defaultMessage="Guardar"/>
                        </button>
                        )}
                        <button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
                          <i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'gerenciadoresAbm.finish_button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'gerenciadoresAbm.finish_button.cancelar', defaultMessage: 'Cancelar' })}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
					</div>
				</div>

        {this.state.showModalDatosComerciales && (
          <ModalDatosComerciales
            key={this.state.modalDatosComercialesKey}
            show={this.state.showModalDatosComerciales}
            onSave={this.handleSaveDatosComerciales}
            onClose={this.handleCloseDatosComerciales}
            data={this.state.editDatosComerciales}
            gerenciadorId={this.state.formData.id}
            ajaxHandler={this.ajaxHandler}
          />
        )}
			</React.Fragment>
		);
	}
}

export default injectIntl(GerenciadoresAbm);
